var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStop = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.92773 1.26855C8.54654 0.911289 9.30893 0.91129 9.92773 1.26855L15.8555 4.69141C16.4742 5.04864 16.8554 5.7084 16.8555 6.42285V13.2686C16.8554 13.983 16.4742 14.6428 15.8555 15L9.92773 18.4229C9.30893 18.7801 8.54654 18.7801 7.92773 18.4229L2 15C1.38126 14.6428 1.00007 13.983 1 13.2686V6.42285C1.00007 5.7084 1.38126 5.04864 2 4.69141L7.92773 1.26855Z",
  fill: "#D9E5E5",
  stroke: "#3F7F7D",
  strokeWidth: 2
})));
export { SvgStop as ReactComponent };
export default __webpack_public_path__ + "assets/1f05d283.svg";